<template>
    <el-scrollbar class="exam-result">
        <div class="exam-result-box">
            <div class="exam-result-box_header">
                <div class="header-label">考试成绩</div>
            </div>

            <div class="exam-result-box_filter">
                <el-cascader
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <el-table
                :data="tableData"
                style="
                    width: 100%;
                    flex: 1;
                    border: 1px solid #f2f4f7;
                    border-radius: 4px;
                "
                size="medium"
                :header-cell-style="{
                    fontWeight: 'normal',
                    color: '#333',
                    background: '#f5f7fa',
                }"
                class="table-content"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column label="试卷" prop="paper_name"></el-table-column>

                <el-table-column label="得分" width="100" :align="'center'">
                    <template slot-scope="scope">
                        {{ !isNaN(scope.row.score) ? scope.row.score.toFixed(2) : "-" }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "ExamResult",
    data() {
        return {
            tableData: [],
            s_id: Number(localStorage.getItem("s_id")),
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
        };
    },
    created() {
        this.getCourseList();
    },
    computed: {},
    methods: {
        // 获取课程列表
        getCourseList() {
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getProjectList();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        getProjectList() {
            if (this.courseValue.length < 2) return;

            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(
                this.$api.evaluation_paper_list,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.tableData = res.data.list || [];
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getProjectList();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
    margin: 0 !important;

    &::-webkit-scrollbar {
        display: none;
    }
}

.exam-result {
    height: 100%;
    height: calc(100vh - 70px);
    box-sizing: border-box;
    padding: 20px;

    .exam-result-box {
        background-color: #ffffff;
        padding: 24px 40px;
        border-radius: 4px;
        box-sizing: border-box;
        min-height: calc(100vh - 112px);

        &_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 24px;
            margin-bottom: 30px;

            .header-label {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 800;
                font-size: 24px;
                color: #333333;
            }

            .el-button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 88px;
                height: 36px;
            }
        }

        &_filter {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }

            ::v-deep .el-input__inner {
                background-color: #ffffff !important;
            }
        }

        .pagination {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
        }
    }
}
</style>
